import grispiApi from '../../../apis/grispiApi';
import { FilterPostDataType } from '../../../components/Forms/CreateFilterForm';

export const createFilter = async (filterPostData: Omit<FilterPostDataType, 'id'>): Promise<void> => {
    await grispiApi.post('/filters', filterPostData);
};

export const updateFilter = async (filterUpdateData: FilterPostDataType): Promise<void> => {
    const { id } = filterUpdateData;
    await grispiApi.put(`/filters/${id}`, filterUpdateData);
};

export const deleteFilter = async (id: number): Promise<void> => {
    await grispiApi.delete(`/filters/${id}`);
};

export const disableFilter = async (id: number): Promise<void> => {
    await grispiApi.post(`/filters/${id}/deactivation`);
};

export const enableFilter = async (id: number): Promise<void> => {
    await grispiApi.delete(`/filters/${id}/deactivation`);
};

export const sortFilters = async (sortedFilters: { filterId: number; order: number }[]): Promise<void> => {
    await grispiApi.patch(`/filters/order`, sortedFilters);
};

export const startExportFilter = async (filterId: number): Promise<void> => {
    await grispiApi.post(`/filters/${filterId}/export`);
};
